import { render } from "./PantryCameraCheckBottomView.vue?vue&type=template&id=44c2b998&ts=true"
import script from "./PantryCameraCheckBottomView.vue?vue&type=script&lang=ts"
export * from "./PantryCameraCheckBottomView.vue?vue&type=script&lang=ts"

import "./PantryCameraCheckBottomView.vue?vue&type=style&index=0&id=44c2b998&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__